const confidenceStyles = {
    high: 'bg-emerald-50 text-emerald-700 border border-emerald-100',
    medium: 'bg-amber-50 text-amber-700 border border-amber-100',
    low: 'bg-rose-50 text-rose-700 border border-rose-100',
};

const getRouteLabel = (row) => {
    const firstStop = row.stops?.[0];
    const lastStop = row.stops?.[row.stops.length - 1];

    return {
        origin: firstStop?.city || firstStop?.name || 'Unknown origin',
        destination: lastStop?.city || lastStop?.name || 'Unknown destination',
    };
};

export const Columns = (selectedRows, setSelectedRows, openModalAdd, item) => {
    const handleCheckboxChange = (row, checked) => {
        if (checked) {
            if (!selectedRows.some((selected) => selected.id === row.id)) {
                setSelectedRows([...selectedRows, row]);
            }
            return;
        }

        setSelectedRows(selectedRows.filter((selected) => selected.id !== row.id));
    };

    return [
        {
            id: 'route',
            name: 'Route',
            grow: 1.4,
            cell: (row) => {
                const route = getRouteLabel(row);

                return (
                    <div className="py-2">
                        <p className="font-semibold text-slate-800">{route.origin} → {route.destination}</p>
                        <p className="text-xs text-slate-500">{row.source_summary || row.reference_number || 'AI draft from uploaded document'}</p>
                    </div>
                );
            },
        },
        {
            id: 'dates',
            name: 'Dates',
            cell: (row) => (
                <div className="py-2 text-xs text-slate-600">
                    <p><span className="font-semibold text-slate-700">Pickup:</span> {row.pickup_date || 'Pending'}</p>
                    <p><span className="font-semibold text-slate-700">Delivery:</span> {row.delivery_date || 'Pending'}</p>
                </div>
            ),
        },
        {
            id: 'equipment',
            name: 'Equipment',
            cell: (row) => (
                <div className="py-2 text-xs text-slate-600">
                    <p><span className="font-semibold text-slate-700">Truck:</span> {row.truck_number_detected || row.truck_id || 'Not matched'}</p>
                    <p><span className="font-semibold text-slate-700">Trailer:</span> {row.trailer_number_detected || row.trailer_id || 'Not matched'}</p>
                </div>
            ),
        },
        {
            id: 'charges',
            name: 'Charges',
            right: true,
            selector: (row) => row.charges || 0,
            cell: (row) => <span className="font-semibold text-slate-800">${Number(row.charges || 0).toLocaleString()}</span>,
        },
        {
            id: 'confidence',
            name: 'Confidence',
            cell: (row) => {
                const confidence = row.extraction_confidence || 'medium';
                const className = confidenceStyles[confidence] || confidenceStyles.medium;

                return (
                    <span className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold capitalize ${className}`}>
                        {confidence}
                    </span>
                );
            },
        },
        {
            id: 'actions',
            name: item.status?.id !== 41 ? 'Actions' : 'Status',
            button: true,
            width: '190px',
            cell: (row) => {
                const isChecked = selectedRows.some((selected) => selected.id === row.id);

                if (item.status?.id === 41) {
                    return <p className="text-xs font-semibold text-emerald-600">Load created</p>;
                }

                return (
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => openModalAdd(row)}
                            className="inline-flex items-center justify-center rounded-lg border border-slate-200 px-3 py-2 text-slate-600 hover:bg-slate-50"
                        >
                            <i className="fas fa-pen text-xs"></i>
                        </button>
                        {row.status ? (
                            <label className="inline-flex items-center gap-2 text-xs font-medium text-slate-700">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-slate-300 text-blue-600"
                                    checked={isChecked}
                                    onChange={(e) => handleCheckboxChange(row, e.target.checked)}
                                />
                                Select
                            </label>
                        ) : (
                            <span className="text-[11px] font-semibold text-amber-600">Complete draft first</span>
                        )}
                    </div>
                );
            },
        },
    ];
};
